export const PRODUCT_SHOW_RESET = 'PRODUCT_SHOW_RESET'
export const PRODUCT_SHOW_SET_ERROR = 'PRODUCT_SHOW_SET_ERROR'
export const PRODUCT_SHOW_SET_RETRIEVED = 'PRODUCT_SHOW_SET_RETRIEVED'
export const PRODUCT_SHOW_TOGGLE_LOADING = 'PRODUCT_SHOW_TOGGLE_LOADING'
